import React from 'react'
import { makeStyles } from '@mui/styles'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Typography from '@mui/material/Typography'

interface PickingAlertButtonProps {
  title: string
  onClick: () => void
}

export const PickingAlertButton: React.FC<PickingAlertButtonProps> = ({
  title,
  onClick
}) => {
  const classes = useStyles()

  return (
    <Card elevation={0} className={classes.card} onClick={onClick}>
      <CardContent className={classes.cardContent}>
        <div className={classes.cardContentText}>
          <Typography
            variant='caption'
            style={{
              width: '100%',
              color: 'lightcoral'
            }}
          >
            Sin Stock
          </Typography>
        </div>
        <div className={classes.cardContentText2}>
          <Typography variant='h6' component='h6'>
            {title}
          </Typography>
        </div>
        {/* You can add more elements here if you want to */}
      </CardContent>
    </Card>
  )
}

const useStyles = makeStyles({
  card: {
    // minWidth: 275,
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#f5f5f5' // Change this color to your desired hover background color
    },
    border: '1px solid lightgray',
    padding: '5px'
  },
  cardContent: {
    display: 'flex',
    flexDirection: 'row',
    padding: 0,
    '&:last-child': {
      paddingBottom: 0
    }
  },
  cardContentText: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // Center the title vertically
    justifyContent: 'flex-start', // Center the title horizontall,
    backgroundColor: 'rgba(255, 189, 189, 0.1)',
    borderRadius: '5px',
    padding: '5px',
    textAlign: 'center'
  },
  cardContentText2: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // Center the title vertically
    justifyContent: 'center' // Center the title horizontall,
  }
})
